import type { filter } from 'utility'
import { CANCELLED_STATUS } from 'utility/constants'
import { manualReviewFilter, manualReviewSelection, ManualReviewRow } from './manualReview'
import { specialOrderFilter } from './specialRequestedOrders'

// Apply after ordinary tab criteria, in both the list/count and the export.
// Manual review owns its IDs; specials owns its IDs only outside manual review.
export function requestedTabMembership (tab: string | null | undefined, specialIds: number[], queue: ManualReviewRow[], executableIds?: number[]): filter[] {
  const manual = tab === 'manualReview'
  return [
    { field: 'cancelation_date', operator: 'is', value: null },
    { field: 'status_id', operator: 'neq', value: CANCELLED_STATUS },
    ...(!manual && executableIds ? [{ field: 'id', operator: 'in', value: executableIds.length ? executableIds : [-1] }] as filter[] : []),
    ...(manual ? [] : specialOrderFilter(specialIds, tab === 'specials') as filter[]),
    ...manualReviewFilter(queue, manual)
  ]
}

export function requestedOrderSelection (selection: string, tab: string | null | undefined): string {
  return tab === 'manualReview' || tab === 'specials' ? manualReviewSelection(selection) : selection
}
